import agGridThemeVariables from './agGridThemeVariables';

const SCROLLBAR_THUMB_STYLE = (color) => ({
    borderRadius: 10,
    background: color,
    backgroundClip: 'content-box',
    border: '2px solid rgba(0, 0, 0, 0)',
});

const scrollbarViewportStyles = (color) => ({
    // Firefox ignores ::-webkit-scrollbar; thin + color keeps the native bar close to 12px.
    scrollbarWidth: 'thin',
    scrollbarColor: `${color} transparent`,
    '&::-webkit-scrollbar': {
        width: 12,
        height: 12,
    },
    '&::-webkit-scrollbar-thumb': SCROLLBAR_THUMB_STYLE(color),
    '&::-webkit-scrollbar-thumb:window-inactive': SCROLLBAR_THUMB_STYLE(color),
});

const MAX_INDENT_LEVEL = 49;

function buildIndentRules() {
    const rules = {};
    for (let level = 1; level <= MAX_INDENT_LEVEL; level += 1) {
        const padding = level * 10;
        rules[`& .ag-ltr .ag-toolpanel-indent-${level}`] = { paddingLeft: padding };
        rules[`& .ag-rtl .ag-toolpanel-indent-${level}`] = { paddingRight: padding };
        rules[`& .ag-ltr .ag-row-group-indent-${level}`] = { paddingLeft: padding };
        rules[`& .ag-rtl .ag-row-group-indent-${level}`] = { paddingRight: padding };
    }
    return rules;
}

export default (theme) => ({
    '& .ag-hidden': {
        display: 'none !important',
    },
    '& .ag-invisible': {
        visibility: 'hidden !important',
    },
    '& .ag-faded': {
        opacity: '0.3',
    },
    '& .ag-width-half': {
        display: 'inline-block',
        width: '50% !important',
    },
    '& .ag-unselectable': {
        userSelect: 'none !important',
    },
    '& .ag-selectable': {
        userSelect: 'text !important',
    },
    '& .ag-select-agg-func-popup': {
        position: 'absolute',
    },
    '& .ag-input-wrapper': {
        display: 'flex',
        flex: '1 1 auto',
        alignItems: 'center',
        lineHeight: 'normal',
        position: 'relative',
        overflow: 'hidden',
    },
    '& .ag-shake-left-to-right': {
        animationDirection: 'alternate',
        animationDuration: '0.2s',
        animationIterationCount: 'infinite',
        animationName: 'ag-shake-left-to-right',
    },
    '& .ag-root-wrapper .ag-watermark': {
        position: 'absolute',
        bottom: 10,
        right: 25,
        opacity: '0.5',
        transition: 'opacity 1s ease-out 3s',
    },
    '& .ag-root-wrapper .ag-watermark:before': {
        content: "''",
        backgroundImage:
            'url(data:image/svg+xml;base64,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)',
        filter: 'invert(50%)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '110px 60px',
        display: 'block',
        height: 60,
        width: 110,
    },
    '& .ag-root-wrapper .ag-watermark .ag-watermark-text': {
        opacity: '0.5',
        fontWeight: 'bold',
        fontFamily: 'Impact',
        fontSize: 19,
    },
    '& .ag-root': {
        cursor: 'default',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '6px',
        overflow: 'hidden',
    },
    // v36 state classes on ag-root must not override the column layout above.
    '& .ag-root.ag-body-horizontal-scroll, & .ag-root.ag-body-vertical-content-no-gap': {
        flexDirection: 'column',
    },
    // Custom scrollbar chrome on AG Grid's dedicated scroll lanes (v36 hides viewport
    // scrollbars and renders the visible vertical bar beside the body via start-spacer).
    // v36 scroll lane offset: use a header-toned border instead of marginTop (margin exposed
    // white body background as a 1px line under hovered header cells).
    '& .ag-body-vertical-scroll-viewport': {
        marginTop: 0,
        borderTop: `1px solid ${theme.colors.actionMinor[50]}`,
        ...scrollbarViewportStyles(theme.colors.grey[100]),
    },
    '& .ag-body-horizontal-scroll-viewport': scrollbarViewportStyles(theme.colors.grey[100]),
    // Firefox still paints a classic bar on overflow:scroll when AG Grid is in overlay mode
    // (ag-scrollbar-invisible → position:absolute; bottom:0). That bar covers the last row
    // and max scrollTop cannot reveal it. Keep the lane in-flow so the viewport shrinks.
    '@supports (-moz-appearance: none)': {
        '& .ag-root > .ag-body-horizontal-scroll.ag-scrollbar-invisible': {
            position: 'relative',
            bottom: 'auto',
            left: 'auto',
            right: 'auto',
        },
    },
    // Layout chain: ag-grid.css is source of truth. JSS is scoped under DataGrid root and
    // outranks the global stylesheet — only declare intentional deltas here.
    '& .ag-root-wrapper': {
        width: '100%',
        minWidth: 0,
        border: 'none !important',
        borderRadius: '6px',
        overflow: 'hidden',
        // ag-grid.css [class*=ag-theme-] sets --ag-* defaults at (0,1,0). Re-apply tokens here
        // at (0,2,0) so they win the cascade and inherit into header/body cells.
        ...agGridThemeVariables(theme),
    },
    '& .ag-root-wrapper-body': {
        width: '100%',
        minWidth: 0,
    },
    // Official uses width:0 as a flex-row grow trick; with our higher specificity that
    // leaves ag-root at 0px wide. flex-basis 0% + minWidth 0 is the reliable equivalent.
    '& .ag-root.ag-layout-normal, & .ag-root.ag-layout-auto-height': {
        flex: '1 1 0%',
        minWidth: 0,
        maxWidth: '100%',
        overflow: 'hidden',
    },
    // v36 DOM: viewport > scrollable-area (flex column, min-height 100%) >
    //   pinned-top (header) + scrolling-rows (flex 1) + pinned-bottom.
    // scrolling-rows is a CHILD of scrollable-area, not a viewport sibling — do not shrink
    // scrollable-area min-height; that collapses the flex context for body rows.
    '& .ag-root.ag-layout-normal .ag-grid-scrollable-area': {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
    },
    '& .ag-root.ag-layout-normal .ag-grid-scrolling-rows': {
        flex: '1 1 auto',
        minHeight: 0,
        minWidth: 0,
    },
    '& .ag-header .ag-header-cell::after': {
        borderRight: '0 !important',
    },
    '& .ag-grid-viewport': {
        '-webkit-overflow-scrolling': 'touch',
    },
    '& .ag-root.ag-layout-normal .ag-grid-viewport': {
        flex: '1 1 auto',
        minHeight: 0,
        minWidth: 0,
        width: '100%',
    },
    '& .ag-body-horizontal-scroll-container': {
        height: '100%',
    },
    '& .ag-virtual-list-container': {
        overflow: 'hidden',
    },
    '& .ag-layout-print .ag-body-horizontal-scroll': {
        display: 'none',
    },
    // v36: pinned header lanes use position:sticky — overflow:hidden on the row or lanes
    // breaks sticky so fixed columns scroll away with the center header.
    // ag-grid.css paints pinned lanes with --ag-background-color (white); force header tone.
    '& .ag-header-row .ag-grid-pinned-left-cells, & .ag-header-row .ag-grid-pinned-right-cells': {
        overflow: 'visible',
        backgroundColor: theme.colors.actionMinor[50],
        backgroundImage: 'none',
    },
    '& .ag-header-row .ag-grid-scrolling-cells': {
        backgroundColor: theme.colors.actionMinor[50],
    },
    '& .ag-header .ag-header-cell-sortable, & .ag-header .ag-grid-pinned-left-cells .ag-header-cell-sortable, & .ag-header .ag-grid-pinned-right-cells .ag-header-cell-sortable':
        {
            cursor: 'pointer',
        },
    '& .ag-header': {
        zIndex: 2, // this makes the w5-actions-component be hidden when being in the same position as header
    },
    '& .ag-header-icon': {
        display: 'flex',
    },
    '& .ag-header .ag-grid-pinned-left-cells': {
        height: '100%',
    },
    '& .ag-header .ag-grid-pinned-right-cells': {
        height: '100%',
    },
    '& .ag-header-row': {
        position: 'absolute',
        overflow: 'visible',
    },
    '& .ag-header-overlay': {
        display: 'block',
        position: 'absolute',
    },
    '& .ag-header-cell': {
        display: 'inline-flex',
        alignItems: 'center',
        position: 'absolute',
        height: '100%',
        overflow: 'hidden',
        lineHeight: '1.5',
    },
    '& .ag-header-group-cell-label, & .ag-header-cell-label': {
        display: 'flex',
        flex: '1 1 auto',
        overflow: 'hidden',
        alignItems: 'center',
        textOverflow: 'ellipsis',
        height: '100%',
    },
    '& .ag-header-cell-label .ag-header-cell-text': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    '& .ag-numeric-header .ag-header-cell-label': {
        flexDirection: 'row-reverse',
    },
    '& .ag-header-group-text': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    '& .ag-header-cell-resize': {
        position: 'absolute',
        zIndex: '1',
        height: '100%',
        width: 4,
        top: 0,
    },
    '& .ag-header-expand-icon': {
        paddingLeft: 4,
    },
    '& .ag-header-select-all': {
        display: 'flex',
        lineHeight: '1',
    },
    '& .ag-column-moving .ag-cell': {
        transition: 'left 0.2s',
    },
    '& .ag-column-moving .ag-header-cell': {
        transition: 'left 0.2s',
    },
    '& .ag-column-moving .ag-header-group-cell': {
        transition: 'left 0.2s, width 0.2s',
    },
    '& .ag-column-panel': {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        flex: '1 1 auto',
    },
    '& .ag-column-select-panel': {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        flexGrow: '4',
        flexShrink: '1',
        flexBasis: '0',
    },
    '& .ag-column-select-panel .ag-primary-cols-header-panel': {
        display: 'flex',
        flex: 'none',
    },
    '& .ag-column-select-panel .ag-primary-cols-header-panel .ag-column-name-filter': {
        flex: '1 1 auto',
    },
    '& .ag-column-select-panel .ag-primary-cols-header-panel .ag-primary-cols-filter-wrapper': {
        flex: '1 1 auto',
    },
    '& .ag-column-select-panel .ag-primary-cols-header-panel .ag-primary-cols-filter-wrapper input':
        {
            width: '100%',
        },
    '& .ag-column-select-panel .ag-primary-cols-list-panel': {
        flex: '1 1 auto',
        overflow: 'auto',
    },
    '& .ag-column-drop': {
        display: 'inline-flex',
        alignItems: 'center',
        overflow: 'auto',
        width: '100%',
    },
    '& .ag-column-drop .ag-column-drop-list': {
        display: 'flex',
        alignItems: 'center',
    },
    '& .ag-column-drop .ag-column-drop-list .ag-column-drop-cell': {
        display: 'flex',
        alignItems: 'center',
    },
    '& .ag-column-drop .ag-column-drop-list .ag-column-drop-cell .ag-column-drop-cell-text': {
        overflow: 'hidden',
        flex: '1 1 auto',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    '& .ag-column-drop.ag-column-drop-vertical': {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        flex: '1 1 0',
        alignItems: 'stretch',
    },
    '& .ag-column-drop.ag-column-drop-vertical > div': {
        display: 'flex',
    },
    '& .ag-column-drop.ag-column-drop-vertical .ag-column-drop-list': {
        alignItems: 'stretch',
        flexGrow: '1',
        flexDirection: 'column',
        overflowX: 'auto',
    },
    '& .ag-column-drop.ag-column-drop-vertical .ag-column-drop-empty-message': {
        display: 'block',
    },
    '& .ag-column-drop.ag-column-drop-horizontal': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    '& .ag-row-animation .ag-row': {
        transition:
            'transform 0.4s, top 0.4s, height 0.4s, background-color 0.1s, opacity 0.2s, -webkit-transform 0.4s',
    },
    '& .ag-row-animation .w5-row-children.ag-row, & .ag-row-animation .w5-row-children.ag-row-even':
        {
            transition:
                'transform 0.4s, top 0.4s, height 0.4s, opacity 0.2s, -webkit-transform 0.4s',
        },
    '& .ag-row-no-animation .ag-row': {
        transition: 'background-color 0.1s',
    },
    '& .ag-row': {
        whiteSpace: 'nowrap',
        width: '100%',
    },
    // When visible columns are narrower than the viewport, AG Grid still sizes the row to
    // column width — stretch the scroll lane and body rows so separators span the full grid.
    '& .ag-grid-viewport .ag-grid-scrolling-container': {
        minWidth: '100%',
    },
    '& .ag-grid-viewport .ag-grid-scrolling-container > .ag-row:not(.ag-header-row)': {
        minWidth: '100%',
    },
    // Let the center lane absorb leftover viewport width so its row border reaches the grid edge.
    '& .ag-row:not(.ag-header-row, .ag-full-width-row) > .ag-grid-scrolling-cells': {
        flex: '1 1 auto',
        minWidth: 0,
        width: '100% !important',
    },
    '& .ag-row-position-absolute': {
        position: 'absolute',
    },
    '& .ag-row-position-relative': {
        position: 'relative',
    },
    // AG Grid v36 renders full-width content in a sticky anchor sized to the viewport
    // via --ag-internal-fw-anchor-width. Clipping the parent row cuts that anchor while
    // the viewport scrolls horizontally; overriding width to 100% of the (scroll-wide)
    // row also prevents sticky from keeping status dividers fixed.
    '& .ag-full-width-row': {
        overflow: 'visible',
        pointerEvents: 'all',
    },
    '& .ag-full-width-anchor': {
        position: 'sticky',
        left: 0,
        width: 'var(--ag-internal-fw-anchor-width, 100%)',
    },
    '& .ag-row-inline-editing': {
        zIndex: '1',
    },
    '& .ag-row-dragging': {
        zIndex: '2',
    },
    '& .ag-stub-cell': {
        display: 'flex',
        alignItems: 'center',
    },
    '& .ag-cell': {
        display: 'inline-block',
        overflow: 'hidden',
        position: 'absolute',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    '& .ag-cell-wrapper': {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
    },
    '& .ag-cell-wrapper.ag-row-group': {
        alignItems: 'flex-start',
    },
    '& .ag-cell-wrapper .ag-cell-value, & .ag-cell-wrapper .ag-group-value': {
        width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    '& .ag-full-width-row.ag-row-group .ag-cell-wrapper': {
        alignItems: 'center',
    },
    '& .ag-cell-with-height': {
        height: '100%',
    },
    '& .ag-group-cell-entire-row': {
        display: 'inline-block',
        height: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
    },
    '& .ag-footer-cell-entire-row': {
        display: 'inline-block',
        height: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
    },
    '& .ag-cell-inline-editing': {
        zIndex: '1',
    },
    '& .ag-cell-inline-editing .ag-cell-edit-input, & .ag-cell-inline-editing .ag-input-text-wrapper':
        {
            height: '100%',
            width: '100%',
            lineHeight: 'normal',
        },
    '& .ag-set-filter-item': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    '& .ag-filter .ag-filter-checkbox': {
        pointerEvents: 'none',
    },
    '& .ag-filter .ag-filter-body-wrapper': {
        display: 'flex',
        flexDirection: 'column',
    },
    '& .ag-filter .ag-filter-filter': {
        flex: '1 1 auto',
    },
    '& .ag-floating-filter-full-body .ag-react-container, & .ag-floating-filter-body .ag-react-container':
        {
            height: '100%',
        },
    '& .ag-floating-filter-body': {
        display: 'flex',
        flex: '1 1 auto',
        height: 20,
    },
    '& .ag-floating-filter-body input': {
        margin: '0',
        flex: '1 1 auto',
    },
    '& .ag-floating-filter-full-body': {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
    '& .ag-floating-filter-full-body > div': {
        flex: '1 1 auto',
    },
    '& .ag-floating-filter-full-body input': {
        margin: '0',
        width: '100%',
    },
    '& .ag-floating-filter-full-body input[type="range"]': {
        height: '100%',
    },
    '& .ag-floating-filter': {
        display: 'inline-block',
        position: 'absolute',
    },
    '& .ag-floating-filter-input': {
        width: '100%',
    },
    '& .ag-floating-filter-input:-moz-read-only': {
        backgroundColor: '#eee',
    },
    '& .ag-floating-filter-input:read-only': {
        backgroundColor: '#eee',
    },
    '& .ag-floating-filter-menu': {
        position: 'absolute',
        userSelect: 'none',
    },
    '& .ag-floating-filter-button': {
        display: 'flex',
        flex: 'none',
    },
    '& .ag-dnd-ghost': {
        display: 'flex',
        alignItems: 'center',
        background: '#e5e5e5',
        border: '1px solid black',
        cursor: 'move',
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: 14,
        lineHeight: '1.4',
        overflow: 'hidden',
        padding: 3,
        position: 'absolute',
        textOverflow: 'ellipsis',
        userSelect: 'none',
        zIndex: '10',
    },
    '& .ag-dnd-ghost-icon': {
        padding: 2,
    },
    '& .ag-overlay': {
        height: '100%',
        left: '0',
        pointerEvents: 'none',
        position: 'absolute',
        top: '0',
        width: '100%',
        zIndex: 1,
    },
    '& .ag-overlay-panel': {
        display: 'flex',
        height: '100%',
        pointerEvents: 'none',
        width: '100%',
    },
    '& .ag-overlay-wrapper': {
        display: 'flex',
        flex: 'none',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
    },
    // No-rows overlays (e.g. documents empty screen) need pointer events for buttons.
    '& .ag-overlay-wrapper:not(.ag-overlay-loading-wrapper):not(.ag-overlay-exporting-wrapper)': {
        pointerEvents: 'all',
        '& .ag-react-container': {
            height: '100%',
            pointerEvents: 'all',
            // v35 may mount multiple React roots; show any container that has content.
            display: 'none',
            '&:not(:empty)': {
                display: 'block',
            },
        },
    },
    // Hidden by default; the root isLoading class re-enables it while data is fetching.
    '& .ag-overlay-wrapper.ag-overlay-loading-wrapper': {
        display: 'none',
        pointerEvents: 'none',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
        textAlign: 'left',
        '& .ag-react-container': {
            width: '100%',
            height: '100%',
            pointerEvents: 'all',
            // v35 may mount multiple React roots; keep only the active overlay visible.
            display: 'none',
            '&:last-child:not(:empty)': {
                display: 'block !important',
            },
        },
    },
    '& .ag-popup > div': {
        zIndex: '5',
    },
    '& .ag-popup-backdrop': {
        height: '100%',
        left: '0',
        position: 'fixed',
        top: '0',
        width: '100%',
    },
    '& .ag-popup-editor': {
        position: 'absolute',
        userSelect: 'none',
        zIndex: '1',
    },
    '& .ag-virtual-list-item': {
        position: 'absolute',
        width: '100%',
    },
    '& .ag-virtual-list-item span:empty:not(.ag-icon)': {
        borderLeft: '1px solid transparent',
    },
    // Do not set overflow:hidden here — v36 header lives inside pinned-top-rows and pinned
    // header lanes use position:sticky; a hidden overflow ancestor breaks horizontal pin.
    // flex-shrink 0: scrollable-area is a column flex; without this the header host can collapse
    // to 0px while the loading overlay/skeleton is visible (infinite/lazy row model).
    '& .ag-grid-pinned-top-rows': {
        flex: '0 0 auto',
        overflow: 'visible',
        whiteSpace: 'nowrap',
        width: '100%',
        minHeight: 'var(--ag-header-rows-height, var(--ag-header-height, 40px))',
    },
    // v36: collapse only the optional pinned-top data row container — never the section that
    // also hosts .ag-header (legacy v35 used ag-invisible on the whole pinned-top block).
    '& .ag-grid-pinned-top-rows.ag-invisible .ag-grid-pinned-top-rows-container': {
        height: '0 !important',
        minHeight: '0 !important',
        pointerEvents: 'none',
    },
    '& .ag-grid-pinned-top-rows.ag-invisible .ag-grid-pinned-top-rows-container .ag-grid-pinned-left-cells, & .ag-grid-pinned-top-rows.ag-invisible .ag-grid-pinned-top-rows-container .ag-grid-pinned-right-cells':
        {
            pointerEvents: 'none',
        },
    '& .ag-grid-pinned-top-rows-container': {
        borderBottom: 'none !important',
    },
    '& .ag-grid-pinned-bottom-rows-container': {
        borderTop: 'none !important',
    },
    '& .ag-grid-pinned-top-rows:not(.ag-invisible)': {
        borderBottom: 'none !important',
    },
    '& .ag-grid-pinned-bottom-rows:not(.ag-invisible)': {
        borderTop: 'none !important',
    },
    '& .ag-grid-pinned-top-rows-container .ag-grid-pinned-left-cells, & .ag-grid-pinned-top-rows-container .ag-grid-pinned-right-cells':
        {
            borderBottom: 'none !important',
        },
    '& .ag-grid-pinned-bottom-rows': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: '100%',
    },
    '& .ag-grid-pinned-bottom-rows-container .ag-grid-pinned-left-cells': {
        overflow: 'hidden',
    },
    '& .ag-grid-pinned-bottom-rows-container .ag-grid-pinned-right-cells': {
        overflow: 'hidden',
    },
    '& .ag-dialog': {
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        overflow: 'hidden',
    },
    '& .ag-dialog .ag-resizer': {
        position: 'absolute',
        pointerEvents: 'none',
        zIndex: '1',
    },
    '& .ag-dialog .ag-resizer.ag-resizer-topLeft': {
        top: '0',
        left: '0',
        height: 5,
        width: 5,
        cursor: 'nwse-resize',
    },
    '& .ag-dialog .ag-resizer.ag-resizer-top': {
        top: '0',
        left: 5,
        right: 5,
        height: 5,
        cursor: 'ns-resize',
    },
    '& .ag-dialog .ag-resizer.ag-resizer-topRight': {
        top: '0',
        right: '0',
        height: 5,
        width: 5,
        cursor: 'nesw-resize',
    },
    '& .ag-dialog .ag-resizer.ag-resizer-right': {
        top: 5,
        right: '0',
        bottom: 5,
        width: 5,
        cursor: 'ew-resize',
    },
    '& .ag-dialog .ag-resizer.ag-resizer-bottomRight': {
        bottom: '0',
        right: '0',
        height: 5,
        width: 5,
        cursor: 'nwse-resize',
    },
    '& .ag-dialog .ag-resizer.ag-resizer-bottom': {
        bottom: '0',
        left: 5,
        right: 5,
        height: 5,
        cursor: 'ns-resize',
    },
    '& .ag-dialog .ag-resizer.ag-resizer-bottomLeft': {
        bottom: '0',
        left: '0',
        height: 5,
        width: 5,
        cursor: 'nesw-resize',
    },
    '& .ag-dialog .ag-resizer.ag-resizer-left': {
        left: '0',
        top: 5,
        bottom: 5,
        width: 5,
        cursor: 'ew-resize',
    },
    '& .ag-dialog .ag-dialog-title-bar': {
        display: 'flex',
        flex: 'none',
        alignItems: 'center',
        cursor: 'default',
    },
    '& .ag-dialog .ag-dialog-title-bar .ag-dialog-title-bar-title': {
        flex: '1 1 auto',
    },
    '& .ag-dialog .ag-dialog-title-bar .ag-dialog-title-bar-buttons': {
        display: 'flex',
    },
    '& .ag-dialog .ag-dialog-title-bar .ag-dialog-title-bar-buttons .ag-dialog-button': {
        cursor: 'pointer',
        height: '100%',
        width: '100%',
        backgroundSize: 'contain',
    },
    '& .ag-dialog .ag-dialog-content-wrapper': {
        display: 'flex',
        flex: '1 1 auto',
        position: 'relative',
        overflow: 'hidden',
    },
    '& .ag-dialog .ag-dialog-content-wrapper > div': {
        width: '100%',
        height: '100%',
    },
    '& .ag-dialog .ag-message-box': {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    '& .ag-dialog .ag-message-box .ag-message-box-content': {
        display: 'flex',
        flex: '1 1 auto',
        justifyContent: 'center',
        alignItems: 'center',
    },
    '& .ag-dialog .ag-message-box .ag-message-box-button-bar': {
        display: 'flex',
        justifyContent: 'center',
    },
    '& .ag-tooltip-custom': {
        position: 'absolute',
        pointerEvents: 'none',
        zIndex: '99999',
        width: 'max-content',
    },
    '& .ag-tooltip-custom .ag-tooltip': { position: 'relative' },
    '& .ag-tooltip': {
        position: 'absolute',
        pointerEvents: 'none',
        zIndex: '99999',
    },
    '& .ag-chart-tooltip': {
        position: 'absolute',
        userSelect: 'none',
        pointerEvents: 'none',
        whiteSpace: 'nowrap',
        zIndex: '99999',
        border: '1px solid gray',
        font: '12px Verdana, sans-serif',
        padding: 7,
        color: 'black',
        background: 'rgba(244, 244, 244, 0.9)',
        boxShadow: '3px 3px 5px rgba(0, 0, 0, 0.3)',
    },
    '& .ag-chart-tooltip .title': {
        fontWeight: 'bold',
    },
    '& .ag-value-slide-out': {
        marginRight: 5,
        opacity: '1',
        transition: 'opacity 3s, margin-right 3s',
        transitionTimingFunction: 'linear',
    },
    '& .ag-value-slide-out-end': {
        marginRight: 10,
        opacity: '0',
    },
    '& .ag-opacity-zero': {
        opacity: '0 !important',
    },
    '& .ag-menu': {
        maxHeight: '100%',
        overflowY: 'auto',
        position: 'absolute',
        userSelect: 'none',
    },
    '& .ag-menu-column-select-wrapper': {
        height: 265,
        overflow: 'auto',
        width: 200,
    },
    '& .ag-menu-list': {
        display: 'table',
    },
    '& .ag-menu-option, & .ag-menu-separator': {
        display: 'table-row',
    },
    '& .ag-menu-option > span, & .ag-menu-separator > span': {
        display: 'table-cell',
        verticalAlign: 'middle',
    },
    '& .ag-menu-option-text': {
        whiteSpace: 'nowrap',
    },
    '& .ag-menu-column-select-wrapper .ag-column-select-panel': {
        height: '100%',
    },
    '& .ag-rich-select': {
        cursor: 'default',
        outline: 'none',
    },
    '& .ag-rich-select .ag-rich-select-value': {
        display: 'flex',
        alignItems: 'center',
    },
    '& .ag-rich-select .ag-rich-select-value > span': {
        flex: '1 1 auto',
    },
    '& .ag-rich-select .ag-rich-select-value .ag-icon': {
        order: '1',
    },
    '& .ag-rich-select .ag-rich-select-list .ag-virtual-list-item': {
        display: 'flex',
    },
    '& .ag-rich-select .ag-rich-select-list .ag-virtual-list-item .ag-rich-select-row': {
        display: 'flex',
        flex: '1 1 auto',
        alignItems: 'center',
        whiteSpace: 'nowrap',
    },
    '& .ag-paging-panel': {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'flex-end',
    },
    '& .ag-paging-page-summary-panel': {
        display: 'flex',
        alignItems: 'center',
    },
    '& .ag-paging-page-summary-panel .ag-disabled': {
        pointerEvents: 'none',
    },
    '& .ag-tool-panel-wrapper': {
        display: 'flex',
        overflowY: 'auto',
        cursor: 'default',

        userSelect: 'none',
        width: 200,
    },
    '& .ag-tool-panel-wrapper .ag-filter-toolpanel-header': {
        cursor: 'pointer',
    },
    '& .ag-column-tool-panel-column, & .ag-column-tool-panel-column-group': {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    '& .ag-column-tool-panel-column .ag-column-tool-panel-column, & .ag-column-tool-panel-column .ag-column-tool-panel-column-group, & .ag-column-tool-panel-column-group .ag-column-tool-panel-column, & .ag-column-tool-panel-column-group .ag-column-tool-panel-column-group':
        {
            flex: '1 1 auto',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    '& .ag-column-select-checkbox': {
        display: 'flex',
    },
    '& .ag-tool-panel-horizontal-resize': {
        cursor: 'col-resize',
        height: '100%',
        position: 'absolute',
        top: '0',
        width: 5,
        zIndex: '1',
    },
    '& .ag-rtl .ag-tool-panel-horizontal-resize': {
        transform: 'translateX(3px)',
    },
    '& .ag-ltr .ag-tool-panel-horizontal-resize': {
        transform: 'translateX(-3px)',
    },
    '& .loading-filter': {
        backgroundColor: '#e6e6e6',
        height: '100%',
        padding: 5,
        position: 'absolute',
        top: 34,
        width: '100%',
        zIndex: '1',
    },
    '& .ag-details-row': {
        height: '100%',
        width: '100%',
    },
    '& .ag-details-grid': {
        height: '100%',
        width: '100%',
    },
    '& .ag-header-group-cell': {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        overflow: 'hidden',
        position: 'absolute',
        textOverflow: 'ellipsis',
    },
    '& .ag-cell-label-container': {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        width: '100%',
    },
    '& .ag-numeric-header .ag-cell-label-container': {
        flexDirection: 'row',
    },
    '& .ag-group-component': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
    },
    '& .ag-group-component .ag-group-component-label': {
        position: 'absolute',
        top: -10,
    },
    '& .ag-group-component .ag-group-item': {
        display: 'flex',
        alignItems: 'center',
        flex: '1 1 auto',
    },
    '& .ag-side-bar': {
        display: 'flex',
        flexDirection: 'row-reverse',
    },
    '& .ag-side-bar .ag-side-buttons div button': {
        display: 'block',
        whiteSpace: 'nowrap',
        outline: 'none',
        cursor: 'pointer',
    },
    '& .ag-side-bar .ag-side-buttons div button span:not(.ag-icon)': {
        writingMode: 'vertical-lr',
    },
    '& .ag-side-bar .panel-container': {
        width: 180,
    },
    '& .ag-side-bar.full-width .panel-container': {
        width: 200,
    },
    '& .ag-rtl .ag-side-bar .ag-side-buttons button span:not(.ag-icon)': {
        writingMode: 'vertical-rl',
    },
    '& .ag-status-bar': {
        display: 'flex',
        justifyContent: 'space-between',
        overflow: 'hidden',
    },
    '& .ag-status-bar .ag-status-panel': {
        display: 'inline-flex',
    },
    '& .ag-status-bar-left': {
        display: 'inline-flex',
    },
    '& .ag-status-bar-center': {
        display: 'inline-flex',
    },
    '& .ag-status-bar-right': {
        display: 'inline-flex',
    },
    ...buildIndentRules(),
    '& .ag-ltr': {
        direction: 'ltr',
    },
    // v36 adds ag-body-horizontal-scroll as a state class on .ag-root — do not include that
    // selector here or ag-root becomes flex-row and the viewport collapses to width 0.
    '& .ag-ltr .ag-grid-pinned-top-rows, & .ag-ltr .ag-grid-pinned-bottom-rows, & .ag-ltr .ag-grid-scrolling-rows, & .ag-ltr .ag-header':
        {
            flexDirection: 'row',
        },
    '& .ag-ltr .ag-root > .ag-body-horizontal-scroll': {
        flexDirection: 'row',
    },
    '& .ag-ltr .ag-header-cell-resize': {
        right: -4,
    },
    '& .ag-ltr .ag-header .ag-grid-pinned-right-cells .ag-header-cell-resize': {
        left: -4,
    },
    '& .ag-rtl': {
        direction: 'rtl',
    },
    '& .ag-rtl .ag-grid-pinned-top-rows, & .ag-rtl .ag-grid-pinned-bottom-rows, & .ag-rtl .ag-grid-scrolling-rows, & .ag-rtl .ag-header':
        {
            flexDirection: 'row-reverse',
        },
    '& .ag-rtl .ag-root > .ag-body-horizontal-scroll': {
        flexDirection: 'row-reverse',
    },
    '& .ag-rtl .ag-header-cell-resize': {
        left: -4,
    },
    '& .ag-rtl .ag-header .ag-grid-pinned-left-cells .ag-header-cell-resize': {
        right: -4,
    },
    '@media print': {
        '& .ag-grid-viewport, & .ag-grid-scrolling-container': {
            display: 'block',
        },
        '& .ag-row': {
            pageBreakInside: 'avoid',
        },
    },
});
